import { cn } from './cn.js';

export interface SkeletonProps {
  className?: string;
}

/**
 * Loading placeholders match the real layout's dimensions. A centred spinner
 * that collapses the page is worse than nothing — the eye loses its place.
 */
export function Skeleton({ className }: SkeletonProps) {
  return (
    <span
      aria-hidden
      className={cn('relative block overflow-hidden rounded bg-surface-sunken', className)}
    >
      <span className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/70 to-transparent" />
    </span>
  );
}

export interface SkeletonRowsProps {
  rows?: number;
  /** Column widths as Tailwind classes, so skeletons line up with real columns. */
  columns?: string[];
}

export function SkeletonRows({
  rows = 8,
  columns = ['w-1/4', 'w-1/6', 'w-1/6', 'w-1/12', 'w-1/6', 'w-1/12'],
}: SkeletonRowsProps) {
  return (
    <div role="status" aria-label="Loading">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div
          key={rowIndex}
          className="flex h-row items-center gap-4 border-b border-line-soft px-4"
        >
          {columns.map((width, colIndex) => (
            <Skeleton key={colIndex} className={cn('h-3', width)} />
          ))}
        </div>
      ))}
    </div>
  );
}
